import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import RoleSelect from "@/pages/RoleSelect";
import CustomerDashboard from "@/pages/CustomerDashboard";
import BusinessDashboard from "@/pages/BusinessDashboard";
import BusinessRegister from "@/pages/BusinessRegister";
import BusinessProfile from "@/pages/BusinessProfile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AppleAuthDone from "@/pages/AppleAuthDone";
import AdminDashboard from "@/pages/AdminDashboard";
import HandoffPage from "@/pages/HandoffPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import "@/App.css";

function DashboardRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!user) return;
    if (user.role === "business") navigate("/business", { replace: true });
    else if (user.role === "customer") navigate("/customer", { replace: true });
    else navigate("/role-select", { replace: true });
  }, [user, navigate]);
  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center">
      <div className="animate-spin h-8 w-8 border-2 border-[#121212] border-t-transparent" />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id synchronously to prevent race conditions
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardRedirect /></ProtectedRoute>} />
      <Route path="/role-select" element={<ProtectedRoute><RoleSelect /></ProtectedRoute>} />
      <Route path="/customer" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
      <Route path="/business" element={<ProtectedRoute><BusinessDashboard /></ProtectedRoute>} />
      <Route path="/business/register" element={<ProtectedRoute><BusinessRegister /></ProtectedRoute>} />
      <Route path="/book/:businessId" element={<BusinessProfile />} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/payment/cancel" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
      <Route path="/auth/apple/done" element={<AppleAuthDone />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/docs" element={<HandoffPage />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
